import { Route, Routes } from "react-router-dom";

import NotFoundPage from "components/error/NotFoundPage";

import WebhookDeliveries from "./Deliveries";
import WebhookDeliveryView from "./Delivery";

const Webhook = () => {
  return (
    <Routes>
      <Route index element={<WebhookDeliveries />} />
      <Route path="delivery/:deliveryId/:statusCode">
        <Route index path="*" element={<WebhookDeliveryView />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};

export default Webhook;
